import { StateSetter } from '@common/services';
import { RefObject } from 'react';
import { useListenDocumentMousedownEvent } from './events';

export function useCloseRefOnOuterClick(args: UseCloseRefOnEventArgs) {
  const { ref, setOpen } = args;

  useListenDocumentMousedownEvent((ev) => {
    if (ref.current && !ref.current?.contains(ev.target as any)) {
      setOpen(false);
    }
  });
}

interface UseCloseRefOnEventArgs {
  ref: RefObject<any>;
  setOpen: StateSetter<boolean>;
}